const CharacterDefault = ({ character }) => (
  <div className="default-character">
    <div className="img">
      <img src="/images/img_avata.svg" alt="" />
    </div>
    <p className="title-item">
      맞춤 정보를 추가해보세요! <br />
      아이가 원하는 캐릭터가 등장합니다!
    </p>
  </div>
)

export default CharacterDefault
